module.exports = __webpack_public_path__ + "static/potatoes-c737a2cc1af1a7500961ac374908dad1.jpg";